import { useOne } from '@refinedev/core';
import { Avatar, Space, theme } from 'antd';
import type { ProfileOut } from '@/api/generated/schemas';
import { ShowIconLink } from '@/components/common/ShowIconLink';

interface ProfileIconLinkProps {
  profileId: number;
  /** Full profile record. When provided, no fetch is performed — lists should
   * pass one from a `useMany` batch instead of paying a request per row. */
  profile?: ProfileOut;
}

/** Profile reference display: avatar + name with a `LinkOutlined` link to
 * the profile show page. Fetches the profile itself when not given one. */
export const ProfileIconLink = ({
  profileId,
  profile,
}: ProfileIconLinkProps) => {
  const { token } = theme.useToken();
  const { result } = useOne<ProfileOut>({
    resource: 'account.profiles',
    id: profileId,
    queryOptions: { enabled: !profile },
  });

  const record = profile ?? result;

  return (
    <ShowIconLink resource="account.profiles" id={profileId}>
      <Space size={6}>
        <Avatar
          size="small"
          src={record?.avatar_url ?? undefined}
          style={
            record?.avatar_url
              ? undefined
              : { backgroundColor: token.colorPrimary }
          }
        >
          {record?.name?.[0]?.toUpperCase() ?? '#'}
        </Avatar>
        {record?.name ?? profileId}
      </Space>
    </ShowIconLink>
  );
};
